import { createInternalLink } from "blog/components/link"
import { NavigationNode, NodeKind } from "blog/json_nodes"

export const createNavigation = (): NavigationNode => ({
  kind: NodeKind.NAVIGATION,
  pages: [
    createInternalLink("/", "Home"),
    createInternalLink("/about", "About"),
  ],
  posts: [
    createInternalLink("/posts/popcorn-is-high-in-protein", "13-05-2020 - Popcorn is high in protein"),
    createInternalLink("/posts/darrell-lea-licorice-dark-chocolate-block", "01-06-2020 - Darrell Lea Licorice Dark Chocolate Block"),
    createInternalLink("/posts/lets-talk-about-stock", "04-06-2020 - Lets Talk About Stock (the food item)"),
    createInternalLink("/posts/how-do-i-put-go-lang-project-anywhere", "30-06-2020 - How Do I: Put my Golang project anywhere"),
    createInternalLink("/posts/get-a-cat", "29-07-2020 - Get a Cat"),
    createInternalLink("/posts/incremental-product-and-engineering", "05-08-2020 - Incremental Product and Engineering"),
    createInternalLink("/posts/training-my-cat-01", "14-08-2020 - Training my Cat: Episode 1"),
  ],
})
